import { Content } from '../../types';

export const chiangRaiContent: Content = {
  title: "צ'אנג ראי – פנינת הצפון של תאילנד",
  imageUrl: '/images/thailand/chiang-rai/chiang-rai-wide.jpeg',
  introduction: `צ'אנג ראי הינה אחת הערים הצפוניות והמרתקות של תאילנד, המשמשת כבסיס יציאה לטיולים באזור משולש הגבולות עם מיאנמר ולאוס. העיר ממוקמת כ-3.5 שעות נסיעה מצ'אנג מאי, אחותה הגדולה ומהווה יעד אידיאלי לחובבי טבע, תרבות והיסטוריה.`,
  sections: [
    {
      title: "האווירה והייחודיות של צ'אנג ראי",
      content: `צ'אנג ראי הינה עיר שלווה ואינטימית, יותר מצ'אנג מאי, מה שהופך אותה למקום נעים למטיילים המחפשים רוגע, נופים עוצרי נשימה ותרבות מקומית עשירה. השילוב בין מקדשים מרשימים, חיי לילה צנועים ואטרקציות טבעיות ייחודיות הופכים את הביקור בה לחוויה בלתי נשכחת.`,
      type: 'text',
    },
    {
      title: 'אתרים מרכזיים בעיר',
      content: [
        {
          subtitle: 'המקדש הלבן (Wat Rong Khun)',
          text: "אחד הסמלים הבולטים של צ'אנג ראי. מדובר במבנה מרהיב בגווני לבן בוהק המעוטר בזכוכית מנצנצת, שנבנה על ידי האמן התאילנדי צ'אלרםצ'אי קוסיטפיפאט. המקום, הוא לא רק מקדש בודהיסטי, אלא גם יצירת אמנות מודרנית המשלבת מסרים דתיים וסאטיריים.",
        },
        {
          subtitle: 'המקדש הכחול (Wat Rong Suea Ten)',
          text: 'מקדש יפהפה נוסף, הפעם בצבעי כחול וזהב מרשימים. המקדש מציע חוויית ביקור מרתקת עם פסלים בודהיסטיים מרהיבים וציורי קיר עשירים בפרטים.',
        },
        {
          subtitle: 'כיכר השעון',
          text: 'כיכר מרכזית בעיר ובה שעון מוזהב בעיצובו של אותו אמן שיצר את המקדש הלבן. בערבים מתקיימים מופעי אורות מרהיבים, מה שהופך את המקום לאטרקציה מעניינת בלב העיר.',
        },
        {
          subtitle: "שוק הלילה של צ'אנג ראי",
          text: 'שוק אותנטי המציע מגוון עבודות יד מקומיות, בגדים, אביזרים ודוכני אוכל תאילנדי מסורתי. זהו מקום נהדר לשוטט בו בערב, ליהנות ממופעים חיים ולחוות את האווירה המקומית.',
        },
        {
          subtitle: 'נהר Mae Kok',
          text: 'נהר זה, אחד מיובליו של נהר המקונג, עובר בליבה של העיר ומציע שייט נעים בין הכפרים הסמוכים, לצד אפשרויות לחוות את התרבות המקומית דרך ביקורים בשבטים החיים באזור.',
        },
      ],
      type: 'sub-headers',
    },
    {
      title: 'אטרקציות מחוץ לעיר',
      content: [
        {
          subtitle: 'הפארק הלאומי Lam Nam Kok ומפל Khun Korn',
          text: "מערבית לצ'אנג ראי נמצא הפארק הלאומי Lam Nam Kok, המציע שבילי הליכה מרהיבים, ג'ונגלים ירוקים ונופים עוצרי נשימה. גולת הכותרת היא מפל Khun Korn, אחד המפלים היפים באזור, המתנשא לגובה של כ-70 מטרים ומוקף בצמחייה טרופית עבותה.",
        },
        {
          subtitle: 'משולש הזהב',
          text: 'אחד האזורים ההיסטוריים והגיאוגרפיים המרתקים בצפון תאילנד, המפגש בין שלוש המדינות – תאילנד, מיאנמר ולאוס. ניתן לבקר במוזיאון האופיום וללמוד על ההיסטוריה הייחודית של המקום.',
        },
        {
          subtitle: 'דוי טונג וארמון המלכה האם',
          text: 'אזור הררי עם נופים עוצרי נשימה, בו נמצא ארמון הקיץ של המלכה האם. המקום מוקף בגנים מטופחים ומספק הצצה לתרבות המלכותית התאילנדית ולפרוייקט החברתי שהוביל לשיפור חייהם של המקומיים באזור.',
        },
        {
          subtitle: 'מעיינות חמים Mae Kachan ו-Doi Saket',
          text: "בדרך לצ'אנג מאי, ניתן לעצור ולהירגע במעיינות החמים הטבעיים Mae Kachan או Doi Saket, שם תוכלו ליהנות ממרחצאות טבעיים ומרגיעים.",
        },
      ],
      type: 'sub-headers',
    },
    {
      title: 'בשורה התחתונה',
      content: `בשורה התחתונה, צ'אנג ראי הינה יעד קסום למטיילים המחפשים חוויה אותנטית, טבע מרהיב ותרבות עשירה. העיר מציעה שילוב נפלא של שלווה, היסטוריה ואטרקציות מגוונות, מה שהופך אותה לנקודת חובה במסלול הצפון של תאילנד.`,
      type: 'text',
    },
  ],
};
